<template>
  <div class="footer">
    <Feedback/>
    <div class="container footer-container">
      <div class="footer-left">
        <span class="footer-left__title">Присоединяйтесь к нам<br>в социальных сетях:</span>
        <div class="footer-socials">
          <a href="https://www.instagram.com/hculture.ru/" target="_blank" class="footer-socials__link"><Instagram/></a>
          <a href="https://vk.com/h_culture" target="_blank" class="footer-socials__link"><Vk/></a>
          <a href="https://www.facebook.com/hculture.ru/" target="_blank" class="footer-socials__link"><Facebook/></a>          
        </div>
      </div>
      <div class="footer-right">
        <span class="footer-right__title">Круглосуточная поддержка:</span>
        <a href="tel:88007072294" class="footer-right__link">8-800-707-22-94</a>
        <span class="footer-right__title">E-mail для связи:</span>
        <a href="mailto:info@hculture.ru" class="footer-right__link">info@hculture.ru</a>
      </div>
    </div>
  </div>
</template>

<script>
import Instagram from '@/assets/svg/instagram.svg';
import Facebook from '@/assets/svg/facebook.svg';
import Vk from '@/assets/svg/vk.svg';
import Feedback from '@/components/Feedback.vue'

export default {
  components: {
    Instagram,
    Facebook,
    Vk,
    Feedback
  }
}
</script>

<style lang="scss" scoped>
.footer {
  margin-top: -5px;
  background: url('/images/footer-bg.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  padding-top: 45px;
  &-container {
    height: 227px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-left {
    &__title {
      font-size: 20px;
      margin-bottom: 20px;
      display: block;
    }
  }
  &-right {
    text-align: right;
    &__title {
      display: block;
      font-size: 20px;
    }
    &__link {
      display: block;
      font-size: 30px;
      color: #fff;
      text-decoration: none;
      margin-bottom: 15px;
      &:last-child {
        margin: 0;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &-socials {
    &__link {
      display: inline-block;
      margin-right: 20px;
    }
  }
}

@media screen and (max-width: 767px) {  
  .footer {
    background-size: cover;
    text-align: center;
    padding: 45px 0;
    padding-top: 0;
    &-container {
      flex-wrap: wrap;
      height: auto;
    }
    &-left {
      width: 100%;
      margin-bottom: 20px;
      &__title {
        margin-bottom: 10px;
      }
    }
    &-right {
      width: 100%;
      text-align: center;
    }
  }
}
</style>